export default __webpack_public_path__ + "static/media/triangle-purple.bfc413dc.svg";